function wrapHTML(el, classes = []) {
  let wrapper = document.createElement('div');
  if (classes.length) wrapper.classList.add(...classes);
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
}

function onScrollComplete(callback, timeout = 200) {
  if ('onscrollend' in window) {
    const handler = () => {
      window.removeEventListener('scrollend', handler);
      callback();
    };
    window.addEventListener('scrollend', handler, { once: true });
  } else {
    let isScrolling;
    const handler = () => {
      clearTimeout(isScrolling);
      isScrolling = setTimeout(() => {
        window.removeEventListener('scroll', handler, { passive: true });
        callback();
      }, timeout);
    };
    window.addEventListener('scroll', handler, { passive: true });
    handler();
  }
}

function addResponsive(el = document) {
  el.querySelectorAll('table').forEach(table => {
    if (!table.closest('.table-responsive')) {
      table.classList.add('table');
      wrapHTML(table, ['table-responsive']);
    }
  });

  el.querySelectorAll('iframe').forEach(frame => {
    if (
      !frame.closest('.embed-responsive') &&
      !frame.closest('media-gallery') &&
      (frame.src.includes('youtube') || frame.src.includes('vimeo'))
    ) {
      wrapHTML(frame, ['embed-responsive', 'embed-responsive-16by9']);
    }
  });
}

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const runWhenIdle = (callback, timeout = 1200) => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(callback, { timeout });
  } else {
    setTimeout(callback, 0);
  }
};

const bindHashScrollLinks = () => {
  const scrollHashes = new Set(['#comments']);

  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const hash = link.hash;
    if (!scrollHashes.has(hash)) return;

    const id = hash.slice(1);
    if (!id) return;

    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    history.pushState(null, null, hash);
  }, { passive: false });

  if (scrollHashes.has(window.location.hash)) {
    const el = document.getElementById(window.location.hash.substring(1));
    el?.scrollIntoView({ behavior: 'smooth' });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  DeviceUtils.init(true);
  bindHashScrollLinks();

  runWhenIdle(() => {
    if (!document.querySelector('table, iframe[src*="youtube"], iframe[src*="vimeo"]')) return;
    addResponsive();
  });
});

let resizeTimeout;

window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    DeviceUtils.init(false);
  }, 100);
});

const docCookies = {
  getItem: function (sKey) {
    if (!sKey || !this.hasItem(sKey)) return null;
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1"));
  },
  setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure, bSameSite) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure|samesite)$/i.test(sKey)) return false;
    let sExpires = "";
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
          break;
        case String:
          sExpires = "; expires=" + vEnd;
          break;
        case Date:
          sExpires = "; expires=" + vEnd.toUTCString();
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires +
      (sDomain ? "; domain=" + sDomain : "") +
      (sPath ? "; path=" + sPath : "") +
      (bSecure ? "; secure" : "") +
      (bSameSite ? "; samesite=" + bSameSite : "; samesite=lax");
    return true;
  },
  removeItem: function (sKey, sPath, sDomain) {
    if (!sKey || !this.hasItem(sKey)) return false;
    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" +
      (sDomain ? "; domain=" + sDomain : "") +
      (sPath ? "; path=" + sPath : "") +
      "; secure; samesite=lax";
    return true;
  },
  hasItem: function (sKey) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure|samesite)$/i.test(sKey)) return false;
    return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
  },
  keys: function () {
    const aKeys = document.cookie
      .replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "")
      .split(/\s*(?:\=[^;]*)?;\s*/);
    for (let nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
    }
    return aKeys;
  },
  isSupported: function () {
    try {
      const testKey = "cookietest";
      this.setItem(testKey, "1");
      const supported = this.hasItem(testKey);
      this.removeItem(testKey);
      return supported;
    } catch (e) {
      return false;
    }
  }
}

class ScrollLock {
  constructor() {
    this.isLocked = false;
  }

  lock() {
    if (this.isLocked) return;
    const body = document.body;
    const stickyHeader = document.querySelector('sticky-header');
    body.classList.add('scroll-locked');
    if (stickyHeader && stickyHeader.isVisible) {
      body.classList.add('block-sticky');
    }
    this.isLocked = true;
  }

  unlock() {
    if (!this.isLocked) return;
    const body = document.body;
    body.classList.remove('scroll-locked', 'block-sticky');
    this.isLocked = false;
  }
}

const scrollLock = new ScrollLock();

class MenuBadges extends HTMLElement {
  constructor() {
    super();
    this._updateTimer = null;
    this._updateRaf = null;
  }

  connectedCallback() {
    runWhenIdle(() => this.updatePosition(0), 1200);
  }

  disconnectedCallback() {
    if (this._updateTimer) clearTimeout(this._updateTimer);
    if (this._updateRaf) cancelAnimationFrame(this._updateRaf);
    this._updateTimer = null;
    this._updateRaf = null;
  }

  updatePosition(delay = 0) {
    if (!this.isConnected) return;
    if (this._updateTimer) clearTimeout(this._updateTimer);
    if (this._updateRaf) cancelAnimationFrame(this._updateRaf);

    const apply = () => {
      this._updateRaf = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const selfWidth = this.offsetWidth;
        if (!selfWidth) return;

        const tabItem = this.closest('.nav-tabs__item');

        if (tabItem) {
          const parent = tabItem.closest('li');
          parent?.style.setProperty('--badge-width', `${selfWidth + 20}px`);
          return;
        }

        const parentLink = this.closest('a');
        if (!parentLink) return;

        const width = selfWidth + 15;
        const height = this.offsetHeight + 14;
        let prevWidth = this.previousElementSibling?.offsetWidth || 0;
        if (this.previousElementSibling) prevWidth += 10;

        let shiftX = parentLink.offsetWidth - prevWidth - width + 15;
        if (shiftX < 0) shiftX = 0;

        parentLink.style.setProperty('--badge-space', `${width}px`);
        parentLink.style.setProperty('--badge-height', `${height}px`);
        parentLink.style.setProperty('--shiftX', `${shiftX}px`);
      });
    };

    if (delay > 0) {
      this._updateTimer = setTimeout(apply, delay);
    } else {
      apply();
    }
  }

  static updateAllPositions() {
    if (!DeviceUtils.isMobile) return;

    requestAnimationFrame(() => {
      const badges = document.querySelectorAll('menu-badges');
      badges.forEach(badge => badge.updatePosition());
    });
  }
}

customElements.define('menu-badges', MenuBadges);

const DrawerManager = (() => {
  let activeDrawer = null;
  let secondaryDrawer = null;
  const drawers = new Map();
  let resizeTimeout = null;

  const manager = {
    register(instance, options = {}) {
      const config = {
        side: options.side || 'left',
        ...options
      };

      drawers.set(instance, config);
    },

    unregister(instance) {
      drawers.delete(instance);
      if (activeDrawer === instance) activeDrawer = null;
      if (secondaryDrawer === instance) secondaryDrawer = null;
    },

    setActive(instance) {
      if (!drawers.has(instance)) return;
      activeDrawer = instance;
    },

    unsetActive(instance) {
      if (activeDrawer === instance) {
        activeDrawer = null;
      }
      instance.classList.remove('is-behind');
      if (instance.scrollLockEnable && secondaryDrawer == null) {
        document.body.classList.remove('overflow-hidden');
        scrollLock.unlock();
      }
      instance.scrollLockEnable = true;
    },

    setSecondary(instance) {
      if (!drawers.has(instance)) return;
      secondaryDrawer = instance;
      secondaryDrawer.scrollLockEnable = false;
      secondaryDrawer.classList.add('is-behind');
    },

    unsetSecondary(instance) {
      if (secondaryDrawer === instance) {
        secondaryDrawer.forceClose();
        secondaryDrawer = null;
      }
    },

    setActiveWithSecondary(newDrawer) {
      const prevActive = this.getActive();
      if (prevActive && prevActive.isOpen) {
        this.setSecondary(prevActive);
        newDrawer?.classList.add('off-backdrop');
      } else {
        newDrawer?.classList.remove('off-backdrop');
      }
      this.setActive(newDrawer);
      return prevActive;
    },

    clearSecondaryIfOpen(currentDrawer) {
      currentDrawer?.classList.remove('off-backdrop');
      const prevActive = this.getSecondary();
      if (prevActive && prevActive.isOpen) {
        this.unsetSecondary(prevActive);
        return true;
      }
      return false;
    },

    getActive() {
      return activeDrawer;
    },

    getSecondary() {
      return secondaryDrawer;
    },

    diffrentSide() {
      if (!activeDrawer || !secondaryDrawer) return false;

      const activeConfig = drawers.get(activeDrawer);
      const secondaryConfig = drawers.get(secondaryDrawer);

      if (!activeConfig || !secondaryConfig) return false;
      return activeConfig.side !== secondaryConfig.side;
    },

    handleWindowResize() {
      if (resizeTimeout) clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const active = this.getActive();
        if (active) {
          active.classList.remove('off-backdrop', 'is-behind');
          if (active.tagName !== 'CART-DRAWER' && !DeviceUtils.isMobile) {
            document.body.classList.remove('overflow-hidden');
            if (typeof scrollLock !== 'undefined') {
              scrollLock.unlock();
            }
          }
        }
      }, 20);
    }
  };

  const handleResize = () => {
    manager.handleWindowResize();
  };

  window.addEventListener('resize', handleResize);

  return manager;
})();

window.DrawerManager = DrawerManager;

document.addEventListener('cart:updated', function (event) {
  const cartData = event.detail.cart;
  const totalPrice = event.detail.totalPrice;
});

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.isFree = false;

    this.fill = this.querySelector('.progress-bar__fill');
    this.progressBarContainer = this.querySelector('.progress-bar-container');
    this.defaultIcon = this.querySelector('.default-icon');
    this.freeIcon = this.querySelector('.free-icon');
    this.defaultText = this.querySelector('.default-text');
    this.freeText = this.querySelector('.free-text');
    this.statusDefault = this.querySelector('.free-shipping__status--default');
    this.statusFree = this.querySelector('.free-shipping__status--free');

    this.cartDrawer = this.closest('cart-drawer') || this.closest('.product-form__free-shipping');

    this.handleCartUpdate = this.handleCartUpdate.bind(this);
  }

  connectedCallback() {
    this.currentValue = parseFloat(this.dataset.value);
    this.maxValue = parseFloat(this.dataset.max);

    this.updateProgressBar();

    document.addEventListener('cart:updated', this.handleCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.handleCartUpdate);
  }

  handleCartUpdate(event) {
    const cartData = event.detail.cart;
    if (!cartData) return;
    this.currentValue = event.detail.totalPrice;
    this.dataset.value = this.currentValue;
    this.updateRemainingAmountText(cartData);
    this.updateProgressBarAnimated();
  }

  updateRemainingAmountText(cartData) {
    const amountSlot = this.querySelector('[data-slot-amount]');
    if (!amountSlot) return;

    const remainingAmount = Math.max(0, this.maxValue - this.currentValue);

    if (remainingAmount > 0) {
      const moneyFormat = this.dataset.moneyFormat;
      const formattedAmount = moneyFormat && typeof formatMoneyShopify === 'function'
        ? formatMoneyShopify(remainingAmount, moneyFormat, cartData.currency || 'USD')
        : new Intl.NumberFormat(window.Shopify?.locale || 'en', {
            style: 'currency',
            currency: cartData.currency || 'USD',
            minimumFractionDigits: 2
          }).format(remainingAmount / 100);

      amountSlot.textContent = formattedAmount;
    }
  }

  updateProgressBar() {
    const percent = Math.min((this.currentValue / this.maxValue) * 100, 100);

    if (!this.fill) return;

    if (this.cartDrawer) {
      this.fill.style.width = percent + '%';
    }

    if (percent >= 100) {
      const isDrawerActive = this.cartDrawer ? this.cartDrawer.classList.contains('active') : true;
      const hasAnimatedClass = this.cartDrawer ? this.cartDrawer.classList.contains('has-animated-progress') : false;

      if (hasAnimatedClass || !isDrawerActive) {
        this.classList.add('progress-bar--complete');
        this.isFree = true;
      } else {
        this.setFreeStatus();
        if (this.cartDrawer) {
          this.cartDrawer.classList.add('has-animated-progress');
        }
      }
    } else {
      if (!this.cartDrawer) {
        this.fill.style.width = percent + '%';
      }
      this.isFree = false;
      this.classList.remove('progress-bar--complete');
      if (this.cartDrawer) {
        this.cartDrawer.classList.remove('has-animated-progress');
      }
      this.resetToDefaultState();
    }
  }

  updateProgressBarAnimated() {
    const oldPercent = parseFloat(this.fill.style.width) || 0;
    const newPercent = Math.min((this.currentValue / this.maxValue) * 100, 100);

    if (Math.abs(oldPercent - newPercent) > 0.1) {
      this.animateProgressBar(newPercent);
    }

    if (newPercent >= 100 && !this.isFree) {
      setTimeout(() => {
        this.setFreeStatus();
      }, 500);
    } else if (newPercent < 100 && this.isFree) {
      this.resetToDefaultState();
    }
  }

  resetToDefaultState() {
    this.isFree = false;
    this.classList.remove('progress-bar--complete');

    if (this.progressBarContainer) {
      this.progressBarContainer.classList.remove('progress-bar--complete');
    }

    if (this.cartDrawer) {
      this.cartDrawer.classList.remove('has-animated-progress');
    }

    if (this.statusDefault) {
      this.statusDefault.style.display = 'flex';
    }
    if (this.statusFree) {
      this.statusFree.style.display = 'none';
    }

    if (this.fill) {
      this.fill.style.background = '';
    }

    if (this.defaultIcon) {
      this.defaultIcon.style.transform = 'translateX(0px)';
      this.defaultIcon.style.opacity = '1';
    }
    if (this.defaultText) {
      this.defaultText.style.transform = 'translateX(0px)';
      this.defaultText.style.opacity = '1';
    }
    if (this.freeIcon) {
      this.freeIcon.style.transform = 'translateX(0px)';
      this.freeIcon.style.opacity = '0';
    }
    if (this.freeText) {
      this.freeText.style.opacity = '0';
    }
  }

  animateProgressBar(targetPercentage) {
    if (!this.fill) return;

    if (typeof motion !== 'undefined') {
      motion.animate(this.fill, { width: `${targetPercentage}%` }, {
        duration: 0.5,
        easing: [0.4, 0, 0.2, 1]
      });
    } else {
      this.fill.style.width = `${targetPercentage}%`;
    }
  }

  popupOpen() {
    if (this.cartDrawer && this.isFree) {
      this.cartDrawer.classList.add('has-animated-progress');
    }
    setTimeout(() => {
      const percentage = Math.min((this.currentValue / this.maxValue) * 100, 100);
      this.animateProgressBar(percentage);
    }, 0);
  }

  setFreeStatus() {
    if (this.isFree) return;
    this.currentValue = this.maxValue;
    this.isFree = true;

    if (!this.fill) return;

    if (typeof motion !== 'undefined') {
      motion.animate(this.fill, { width: '100%' }, {
        duration: 0.3,
        easing: [0.4, 0, 0.2, 1]
      });
    } else {
      this.fill.style.width = '100%';
    }

    setTimeout(() => {
      if (this.fill) this.fill.style.background = 'var(--color-free-shipping)';

      if (typeof motion !== 'undefined') {
        if (this.defaultText) {
          motion.animate(this.defaultText, { x: 50, opacity: 0 }, {
            duration: 0.3,
            easing: 'ease-in-out'
          });
        }

        if (this.defaultIcon) {
          motion.animate(this.defaultIcon, { x: 50, opacity: 0 }, {
            duration: 0.35,
            easing: 'ease-in-out'
          });
        }
      } else {
        if (this.defaultText) this.defaultText.style.opacity = '0';
        if (this.defaultIcon) this.defaultIcon.style.opacity = '0';
      }

      setTimeout(() => {
        if (this.statusDefault) this.statusDefault.style.display = 'none';
        if (this.statusFree) this.statusFree.style.display = 'flex';

        if (typeof motion !== 'undefined') {
          if (this.freeIcon) {
            motion.animate(this.freeIcon, { x: [-50, 0], opacity: 1 }, {
              duration: 0.3,
              easing: 'ease-out'
            });
          }

          if (this.freeText) {
            motion.animate(this.freeText, { opacity: [0, 1] }, {
              duration: 0.2,
              easing: 'ease-out',
              delay: 0.2
            });
          }
        } else {
          if (this.freeIcon) this.freeIcon.style.opacity = '1';
          if (this.freeText) this.freeText.style.opacity = '1';
        }

        if (this.progressBarContainer) {
          this.progressBarContainer.classList.add('progress-bar--complete');
        }
        this.classList.add('progress-bar--complete');
      }, 350);
    }, 50);
  }

  resetProgress() {
    if (!this.fill) return;

    this.fill.style.transition = 'none';
    this.fill.style.width = '0%';

    setTimeout(() => {
      this.fill.style.transition = '';
    }, 0);
  }
}

customElements.define('progress-bar', ProgressBar);

class DetailsSlide extends HTMLElement {
  constructor() {
    super();

    this.checkbox = null;
    this.cartDrawer = this.closest('cart-drawer');
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
  }

  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"].details__checkbox');

    if (this.checkbox) {
      this.checkbox.addEventListener('change', this.onCheckboxChange);

      if (this.checkbox.checked) {
        this.onShow();
      } else {
        this.onClose();
      }
    }
  }

  disconnectedCallback() {
    if (this.checkbox) {
      this.checkbox.removeEventListener('change', this.onCheckboxChange);
    }
  }

  onCheckboxChange(event) {
    if (event.target.checked) {
      this.onShow();
    } else {
      this.onClose();
    }
  }

  onShow() {
    this.dispatchEvent(new CustomEvent('show', {
      bubbles: true,
      detail: { element: this }
    }));
    const isMobile = DeviceUtils.isMobile;
    if (!isMobile && this.cartDrawer) this.cartDrawer.updateContentHeight();
  }

  onClose() {
    this.dispatchEvent(new CustomEvent('close', {
      bubbles: true,
      detail: { element: this }
    }));
    const isMobile = DeviceUtils.isMobile;
    if (!isMobile && this.cartDrawer) this.cartDrawer.updateContentHeight();
  }

  toggle() {
    if (this.checkbox) {
      this.checkbox.checked = !this.checkbox.checked;
      this.onCheckboxChange({ target: this.checkbox });
    }
  }
}

customElements.define('details-slide', DetailsSlide);

class CopyToClipboard extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this._hideTimeout = null;
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    clearTimeout(this._hideTimeout);
  }

  async handleClick() {
    const text = this.dataset.text;
    if (!text) return;

    await navigator.clipboard.writeText(text);

    this.setAttribute('data-copied', 'true');

    clearTimeout(this._hideTimeout);
    this._hideTimeout = setTimeout(() => {
      this.removeAttribute('data-copied');
      this._hideTimeout = null;
    }, 2000);
  }
}

customElements.define('copy-to-clipboard', CopyToClipboard);

class CardHover extends HTMLElement {
  static instances = new Set();
  static resizeListenerAttached = false;
  static resizeRaf = null;

  static handleGlobalResize() {
    if (CardHover.resizeRaf) return;

    CardHover.resizeRaf = requestAnimationFrame(() => {
      CardHover.resizeRaf = null;

      CardHover.instances.forEach((instance) => {
        if (!instance?.isConnected) return;
        instance.handleResize();
      });
    });
  }

  static attachResizeListener() {
    if (CardHover.resizeListenerAttached) return;

    window.addEventListener('resize', CardHover.handleGlobalResize);
    CardHover.resizeListenerAttached = true;
  }

  static detachResizeListenerIfIdle() {
    if (CardHover.instances.size > 0 || !CardHover.resizeListenerAttached) return;

    window.removeEventListener('resize', CardHover.handleGlobalResize);
    CardHover.resizeListenerAttached = false;

    if (CardHover.resizeRaf) {
      cancelAnimationFrame(CardHover.resizeRaf);
      CardHover.resizeRaf = null;
    }
  }

  constructor() {
    super();

    this.resizeTimeout = null;
    this.isResizing = false;
    this.cachedHeight = null;
    this.heightMeasureRaf = null;

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleFocusIn = this.handleFocusIn.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.checkDeviceType = this.checkDeviceType.bind(this);

    this.config = {
      heightProperty: '--card-max-height',
      hoverSelector: '.card__information-hover',
      heightSelector: '.card',
      heightOffset: parseInt(this.getAttribute('data-height-offset')) || 0,
      heightContainer: null,
      needsResize: false
    };
  }

  connectedCallback() {
    CardHover.instances.add(this);
    CardHover.attachResizeListener();

    this.initElements();
    this.checkDeviceType();
  }

  disconnectedCallback() {
    CardHover.instances.delete(this);
    CardHover.detachResizeListenerIfIdle();

    this.removeEventListener('mouseenter', this.handleMouseEnter);
    this.removeEventListener('mouseleave', this.handleMouseLeave);
    this.removeEventListener('focusin', this.handleFocusIn);
    this.removeEventListener('focusout', this.handleFocusOut);

    if (this.heightMeasureRaf) {
      cancelAnimationFrame(this.heightMeasureRaf);
      this.heightMeasureRaf = null;
    }

    clearTimeout(this.resizeTimeout);
  }

  initElements() {
    this.hoverElement = this.querySelector(this.config.hoverSelector);
    this.heightContainer = this.config.heightContainer || this;
  }

  checkDeviceType() {
    if (DeviceUtils.isMobile) {
      this.removeEventListener('mouseenter', this.handleMouseEnter);
      this.removeEventListener('mouseleave', this.handleMouseLeave);
      this.removeEventListener('focusin', this.handleFocusIn);
      this.removeEventListener('focusout', this.handleFocusOut);

      this.heightContainer?.style.removeProperty(this.config.heightProperty);
    } else {
      this.addEventListener('mouseenter', this.handleMouseEnter);
      this.addEventListener('mouseleave', this.handleMouseLeave);
      this.addEventListener('focusin', this.handleFocusIn);
      this.addEventListener('focusout', this.handleFocusOut);
    }
  }

  handleResize() {
    this.checkDeviceType();

    if (!this.isResizing) {
      this.isResizing = true;
      this.heightContainer?.style.removeProperty(this.config.heightProperty);
    }

    this.cachedHeight = null;

    clearTimeout(this.resizeTimeout);

    this.resizeTimeout = setTimeout(() => {
      this.isResizing = false;

      if (
        !DeviceUtils.isMobile &&
        (this.matches(':hover') || this.matches(':focus-within'))
      ) {
        this.updateHeight();
      }
    }, 400);
  }

  handleMouseEnter() {
    if (DeviceUtils.isMobile) return;

    if (this.heightMeasureRaf) {
      cancelAnimationFrame(this.heightMeasureRaf);
    }

    this.heightMeasureRaf = requestAnimationFrame(() => {
      this.heightMeasureRaf = null;
      this.updateHeight();
    });
  }

  handleMouseLeave() {
    if (DeviceUtils.isMobile) return;

    if (this.heightMeasureRaf) {
      cancelAnimationFrame(this.heightMeasureRaf);
      this.heightMeasureRaf = null;
    }

    this.blurFocusedChild();

    this.heightContainer?.style.removeProperty(this.config.heightProperty);
  }

  blurFocusedChild() {
    const active = document.activeElement;

    if (active && active !== this && this.contains(active)) {
      active.blur();
    }
  }

  handleFocusIn() {
    this.handleMouseEnter();
  }

  handleFocusOut(event) {
    if (this.contains(event.relatedTarget)) return;

    this.handleMouseLeave();
  }

  calculateHeight() {
    const element = this.config.heightSelector
      ? this.querySelector(this.config.heightSelector)
      : this;

    const rect = element.getBoundingClientRect();

    return rect.height + this.config.heightOffset;
  }

  updateHeight() {
    if (DeviceUtils.isMobile || !this.heightContainer) return;

    if (this.cachedHeight !== null) {
      const cachedMaxHeight = `${this.cachedHeight}px`;

      if (
        this.heightContainer.style.getPropertyValue(this.config.heightProperty) !==
        cachedMaxHeight
      ) {
        this.heightContainer.style.setProperty(
          this.config.heightProperty,
          cachedMaxHeight
        );
      }

      return;
    }

    if (this.hoverElement) {
      this.hoverElement.style.position = 'absolute';
      this.hoverElement.style.opacity = '0';
    } else {
      this.config.heightOffset = 0;
    }

    const height = this.calculateHeight();

    this.cachedHeight = height;

    const newMaxHeight = `${height}px`;

    const currentMaxHeight = this.heightContainer.style.getPropertyValue(
      this.config.heightProperty
    );

    if (currentMaxHeight !== newMaxHeight) {
      this.heightContainer.style.setProperty(
        this.config.heightProperty,
        newMaxHeight
      );
    }

    requestAnimationFrame(() => {
      if (this.hoverElement) {
        this.hoverElement.style.position = '';
        this.hoverElement.style.opacity = '';
      }
    });
  }
}

customElements.define('card-hover', CardHover);

class ProductImageAnimator {
  constructor(variantSelectsComponent) {
    this.component = variantSelectsComponent;
    this.isAnimating = false;
    this.pendingSrc = null;
    this.originalLinkPointerEvents = '';
    this.duration = 500;
    this.easing = 'cubic-bezier(0.33, 1, 0.68, 1)';
    this._onComplete = null;
  }

  animate(mediaContainer, newSrc, onComplete = null) {
    if (this.shouldSkipAnimation(mediaContainer, newSrc)) return;

    this._onComplete = onComplete;
    this.prepareForAnimation();

    const preloadImage = new Image();
    preloadImage.src = newSrc;

    const executeAnimation = () => {
      this.removeMatchingHoverImages(mediaContainer, newSrc);
      const clone = this.createAnimationClone(mediaContainer, newSrc);
      this.setupCloneContainer(mediaContainer, clone);
      this.animateClone(clone);
      this.updateOriginalImages(mediaContainer, newSrc, clone);
    };

    if (preloadImage.complete) {
      executeAnimation();
    } else {
      preloadImage.onload = executeAnimation;
      preloadImage.onerror = () => this.handleAnimationError(mediaContainer);
    }
  }

  instantUpdate(mediaContainer, newSrc) {
    const images = mediaContainer.querySelectorAll('img:not(.image-hover)');
    images.forEach(img => {
      img.src = newSrc;
      img.srcset = '';
    });
  }

  shouldSkipAnimation(mediaContainer, newSrc) {
    if (this.isAnimating) {
      this.pendingSrc = newSrc;
      return true;
    }

    const currentImg = mediaContainer.querySelector('img.image-default, img:first-of-type');
    if (!currentImg) return true;

    const currentSrc = this.normalizeUrl(currentImg.src);
    const normalizedNewSrc = this.normalizeUrl(newSrc);
    return currentSrc === normalizedNewSrc;
  }

  normalizeUrl(url) {
    if (!url) return '';
    const match = url.match(/\/files\/([\w\-\.]+\.(jpg|jpeg|png|gif|webp))(\?v=\d+)?/i);
    return match ? match[1] : url;
  }

  prepareForAnimation() {
    const productCard = this.component.closest('product-card') || this.component;
    if (productCard.dataset.section === 'complementary-products') {
      this.isAnimating = true;
      return;
    }

    const allBadges = productCard.querySelectorAll('.product__badges');
    const countdownTimers = productCard.querySelectorAll('countdown-timer');

    allBadges.forEach(badge => {
      badge.style.position = 'absolute';
      badge.style.zIndex = '100';
    });
    countdownTimers.forEach(timer => {
      timer.style.position = 'absolute';
      timer.style.zIndex = '100';
    });

    this.isAnimating = true;
  }

  removeMatchingHoverImages(mediaContainer, newSrc) {
    const newSrcNormalized = this.normalizeUrl(newSrc);
    const hoverImages = mediaContainer.querySelectorAll('img.image-hover');

    const shouldRemove = Array.from(hoverImages).some(img =>
      this.normalizeUrl(img.src) === newSrcNormalized
    );

    if (shouldRemove) {
      hoverImages.forEach(img => img.remove());
    }
  }

  createAnimationClone(mediaContainer, newSrc) {
    const clone = mediaContainer.cloneNode(true);

    clone.classList.remove('media--hover-swap', 'media--hover-zoom', 'aspect-ratio-settings', 'aspect-ratio-auto');
    clone.removeAttribute('style');
    clone.classList.add('media-fade-clone');

    const allImages = clone.querySelectorAll('img');
    const defaultImg = clone.querySelector('img.image-default') || clone.querySelector('img:not(.image-hover)');

    allImages.forEach(img => {
      if (img !== defaultImg) {
        img.remove();
      }
    });

    const cloneImg = defaultImg;
    if (cloneImg) {
      cloneImg.srcset = '';
      ['data-src', 'data-srcset', 'loading', 'width', 'height'].forEach(attr => cloneImg.removeAttribute(attr));
      cloneImg.src = newSrc;
      cloneImg.style.opacity = '1';
      cloneImg.style.visibility = 'visible';
      cloneImg.style.transform = 'scale(1.15)';
      cloneImg.style.transformOrigin = 'center';
      cloneImg.style.transition = 'none';
    }

    clone.style.cssText = `position:absolute!important;top:0!important;left:0!important;width:100%!important;height:100%!important;z-index:5!important;opacity:0!important;transition:none!important;pointer-events:none!important;overflow:hidden!important`;

    return clone;
  }

  setupCloneContainer(mediaContainer, clone) {
    const parent = mediaContainer.closest('.product-card__media') || mediaContainer.parentElement;
    if (!parent.style.position || parent.style.position === 'static') {
      parent.style.position = 'relative';
    }

    const existingClones = parent.querySelectorAll('.media-fade-clone');
    existingClones.forEach(oldClone => oldClone.remove());

    const parentLink = mediaContainer.closest('a');
    if (parentLink) {
      this.originalLinkPointerEvents = parentLink.style.pointerEvents;
      parentLink.style.pointerEvents = 'none';
    }

    parent.appendChild(clone);
  }

  animateClone(clone) {
    const cloneImg = clone.querySelector('img');

    const startAnimation = () => {
      requestAnimationFrame(() => {
        clone.style.transition = `opacity ${this.duration}ms ${this.easing}`;
        if (cloneImg) {
          cloneImg.style.transition = `transform ${this.duration}ms ${this.easing}`;
        }

        requestAnimationFrame(() => {
          clone.style.opacity = '1';
          if (cloneImg) {
            cloneImg.style.transform = 'scale(1)';
          }
        });
      });
    };

    if (cloneImg && cloneImg.complete && cloneImg.naturalHeight !== 0) {
      startAnimation();
    } else if (cloneImg) {
      cloneImg.onload = startAnimation;
      cloneImg.onerror = startAnimation;
    } else {
      startAnimation();
    }
  }

  updateOriginalImages(mediaContainer, newSrc, clone) {
    setTimeout(() => {
      const originalImages = mediaContainer.querySelectorAll('img:not(.image-hover)');

      if (originalImages.length > 0) {
        originalImages.forEach(img => {
          img.style.opacity = '0';
          img.style.visibility = 'hidden';
          img.src = newSrc;
          img.srcset = '';
        });

        this.waitForImagesToLoad(originalImages, () => {
          originalImages.forEach(img => {
            img.style.opacity = '1';
            img.style.visibility = 'visible';
          });

          requestAnimationFrame(() => {
            if (clone && clone.parentNode) clone.remove();
          });

          this.finishAnimation(mediaContainer);
        });
      } else {
        if (clone && clone.parentNode) clone.remove();
        this.finishAnimation(mediaContainer);
      }
    }, this.duration);
  }

  waitForImagesToLoad(images, callback) {
    let loadedCount = 0;
    const totalImages = images.length;
    let callbackCalled = false;

    const safeCallback = () => {
      if (!callbackCalled) {
        callbackCalled = true;
        callback();
      }
    };

    const fallbackTimeout = setTimeout(() => {
      safeCallback();
    }, 300);

    const checkComplete = () => {
      loadedCount++;
      if (loadedCount >= totalImages) {
        clearTimeout(fallbackTimeout);
        safeCallback();
      }
    };

    const checkImageLoaded = (img) => {
      if (img.complete && img.naturalHeight !== 0) {
        checkComplete();
      } else {
        setTimeout(() => checkImageLoaded(img), 10);
      }
    };

    images.forEach(img => {
      if (img.complete && img.naturalHeight !== 0) {
        checkComplete();
      } else {
        img.onload = () => checkImageLoaded(img);
        img.onerror = () => checkComplete();

        const currentSrc = img.src;
        img.src = '';
        img.src = currentSrc;
      }
    });
  }

  finishAnimation(mediaContainer) {
    const parentLink = mediaContainer.closest('a');
    if (parentLink && this.originalLinkPointerEvents !== undefined) {
      parentLink.style.pointerEvents = this.originalLinkPointerEvents;
    }

    this.isAnimating = false;

    if (this._onComplete) {
      const cb = this._onComplete;
      this._onComplete = null;
      cb();
    }

    if (this.pendingSrc) {
      const pendingSrc = this.pendingSrc;
      this.pendingSrc = null;
      this.animate(mediaContainer, pendingSrc);
    }
  }

  handleAnimationError(mediaContainer) {
    this.isAnimating = false;

    if (this._onComplete) {
      const cb = this._onComplete;
      this._onComplete = null;
      cb();
    }

    if (this.pendingSrc) {
      const pendingSrc = this.pendingSrc;
      this.pendingSrc = null;
      this.animate(mediaContainer, pendingSrc);
    }
  }
}

class ProductCard extends CardHover {
  preProcessHtmlCallbacks = [];

  constructor() {
    super();
    this.wrapper = this.closest('.product-card-wrapper');
    this.imageAnimator = new ProductImageAnimator(this);
    this._moreOptionsCountRAF = null;
    this._moreOptionsCountIdleTimer = null;
    this._activeSwatchReplayDone = false;

    this.config = {
      heightProperty: '--product-card-max-height',
      hoverSelector: '.product-card__hover',
      heightSelector: null,
      heightOffset: 0,
      heightContainer: this.wrapper,
      needsResize: !!this.wrapper
    };

    if (this.hasAttribute('data-highlight')) {
      this.initHighlight();
    }
  }

  initHighlight() {
    const media = this.querySelector('.product-card__media');
    if (!media) return;

    this._highlightObserver?.disconnect();

    this._highlightObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;

      const isFrameVisible = entry.isIntersecting;
      const isBadgeVisible = entry.intersectionRatio >= 0.95;

      this.classList.toggle('is-highlight-active', isFrameVisible);
      this.classList.toggle('is-highlighted', isBadgeVisible);
    }, {
      rootMargin: '0px',
      threshold: [0, 0.95]
    });

    this._highlightObserver.observe(media);
  }

  connectedCallback() {
    super.connectedCallback();

    this.onVariantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.optionValueSelectionChange,
      this._handleOptionValueChange.bind(this)
    );

    if (window.tooltipInstance) {
      window.tooltipInstance.init(this);
    }

    this.scheduleActiveSwatchReplay();
    this.scheduleMoreOptionsCountUpdate(true);
  }

  handleResize() {
    super.handleResize();
    this.scheduleMoreOptionsCountUpdate(false);
  }

  _handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
    if (!this.contains(event.target)) return;

    const shouldRestoreFocus = document.activeElement === target;

    if (this.variantSelectors?.onlyColors) {
      const mediaSrc = event.target.dataset.mediaSrc;
      if (mediaSrc) this._applyMediaSrc(mediaSrc);
      return;
    }

    this._resetProductFormState();
    this._renderProductInfo({
      requestUrl: this._buildRequestUrlWithParams(this.dataset.url, selectedOptionValues),
      targetId: target.id,
      shouldRestoreFocus,
      callback: this._handleUpdateProductInfo(),
    });
  }

  _handleUpdateProductInfo(productUrl) {
    return (html) => {
      const variant = this._getSelectedVariant(html);

      this._updateOptionValues(html);
      this._updateVariantInputs(variant?.id);

      if (!variant) {
        this._setUnavailable();
        return;
      }

      this._updateMedia(variant);
      this._updateLinks(variant, html);

      const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
        const source = html.getElementById(`${id}-${this.dataset.section}-${this.dataset.productId}`);
        const destination = this.querySelector(`#${id}-${this.dataset.section}-${this.dataset.productId}`);
        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          destination.classList.toggle('hidden', shouldHide(source));
        }
      };

      updateSourceFromDestination('price');
      updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
      updateSourceFromDestination('Badges', ({ innerText }) => innerText === '');

      const badgeDestination = this.querySelector(`#Badges-${this.dataset.section}-${this.dataset.productId}`);
      if (badgeDestination) {
        const newBadges = badgeDestination.querySelectorAll('.product__badges');
        newBadges.forEach(badge => {
          badge.style.transition = 'none';
          badge.style.opacity = '0';
        });
      }

      updateSourceFromDestination('Title');
      this.productForm?.toggleSubmitButton?.(
        html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
        window.variantStrings.soldOut
      );

      this.scheduleMoreOptionsCountUpdate(false);
      this.invalidateHeightCache();
    };
  }

  invalidateHeightCache() {
    this.cachedHeight = null;
    if (!DeviceUtils.isMobile && this.matches(':hover')) {
      this.updateHeightIfChanged();
    }
    this.scheduleMoreOptionsCountUpdate(false);
  }

  updateHeightIfChanged() {
    if (DeviceUtils.isMobile || !this.heightContainer) return;

    if (this.hoverElement) {
      this.hoverElement.style.position = 'absolute';
      this.hoverElement.style.opacity = '0';
    }

    const newHeight = this.calculateHeight();
    const newMaxHeight = `${newHeight}px`;
    const current = this.heightContainer.style.getPropertyValue(this.config.heightProperty);

    if (current !== newMaxHeight) {
      this.cachedHeight = newHeight;
      this.heightContainer.style.setProperty(this.config.heightProperty, newMaxHeight);
    } else {
      this.cachedHeight = newHeight;
    }

    requestAnimationFrame(() => {
      if (this.hoverElement) {
        this.hoverElement.style.position = '';
        this.hoverElement.style.opacity = '';
      }
    });
  }

  _setUnavailable() {
    this.productForm?.toggleSubmitButton?.(true, window.variantStrings.unavailable);

    const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
      .map((id) => `#${id}-${this.dataset.section}`)
      .join(', ');
    this.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
  }

  _applyMediaSrc(src) {
    const productCardMedia = this.querySelector('.product-card__media');
    const loopSlider = this.querySelector('loop-slider');
    const isHiddenVariants = productCardMedia?.hasAttribute('data-hidden-variants');

    if (!isHiddenVariants && loopSlider?.addMedia) {
      loopSlider.addMedia(src);
      return;
    }

    if (loopSlider && isHiddenVariants && loopSlider.currentIndex !== 0) {
      this._animateOnCurrentThenJump(loopSlider, src);
      return;
    }

    if (typeof loopSlider?.updatePositions === 'function') {
      loopSlider.updatePositions({ animate: false });
    }
    this._updateMediaContainers(src);
  }

  scheduleActiveSwatchReplay() {
    if (this._activeSwatchReplayDone) return;
    this._activeSwatchReplayDone = true;

    const replay = () => {
      const selectedSwatch = this.querySelector('.swatch-input__input:checked[data-media-src]');
      if (!selectedSwatch) return;
      if (this._isSelectedSwatchMediaAlreadyApplied(selectedSwatch)) return;
      selectedSwatch.dispatchEvent(new Event('change', { bubbles: true }));
    };

    setTimeout(replay, 120);
  }

  _normalizeMediaSrc(src) {
    if (!src) return '';

    try {
      const url = new URL(src, window.location.origin);
      return `${url.origin}${url.pathname}`;
    } catch (_) {
      return src.split('?')[0];
    }
  }

  _getCurrentPrimaryMediaSrc() {
    const productCardMedia = this.querySelector('.product-card__media');
    const loopSlider = this.querySelector('loop-slider');

    const activeSlide =
      loopSlider?.querySelector('.loop-slider__slide.is-active, .loop-slider__slide[aria-hidden="false"]')
      || loopSlider?.querySelector('.loop-slider__slide')
      || productCardMedia;

    const image = activeSlide?.querySelector('img:not(.image-hover)');
    return image?.currentSrc || image?.src || image?.dataset?.src || '';
  }

  _isSelectedSwatchMediaAlreadyApplied(selectedSwatch) {
    const swatchSrc = this._normalizeMediaSrc(selectedSwatch?.dataset?.mediaSrc || '');
    const currentSrc = this._normalizeMediaSrc(this._getCurrentPrimaryMediaSrc());

    return Boolean(swatchSrc && currentSrc && swatchSrc === currentSrc);
  }

  _updateMedia(variant) {
    const src = variant?.featured_media?.preview_image?.src;
    if (src) this._applyMediaSrc(src);
  }

  _updateLinks(variant, html) {
    const fallbackUrl = variant?.id ? `${this.dataset.url}?variant=${variant.id}` : this.dataset.url;
    const titleId = `Title-${this.dataset.section}-${this.dataset.productId}`;
    const sourceLink =
      html.querySelector('.product-card__media a[href]') ||
      html.querySelector('.product-card__heading a[href]') ||
      html.querySelector('.product-card__title a[href]') ||
      html.querySelector(`#${CSS.escape(titleId)} a[href]`);
    const nextUrl = sourceLink?.getAttribute('href') || variant?.url || fallbackUrl;

    if (!nextUrl) return;

    const links = new Set([
      ...this.querySelectorAll('.product-card__media a, .product-card__heading a, .product-card__title a'),
      ...this.querySelectorAll(`#${CSS.escape(titleId)} a`)
    ]);

    links.forEach((link) => {
      link.setAttribute('href', nextUrl);
      link.href = nextUrl;
    });
  }

  _updateMediaContainers(src, isInstant = false) {
    const productCardMedia = this.querySelector('.product-card__media');
    const loopSlider = this.querySelector('loop-slider');
    const mediaContainers = productCardMedia?.querySelectorAll('.media');
    const method = isInstant ? 'instantUpdate' : 'animate';

    if (mediaContainers && mediaContainers.length > 0) {
      this.imageAnimator[method](mediaContainers[0], src);
      if (loopSlider?.hasAttribute('data-double') && mediaContainers[2]) {
        this.imageAnimator.instantUpdate(mediaContainers[2], src);
      }
    }
  }

  _animateOnCurrentThenJump(loopSlider, src) {
    const productCardMedia = this.querySelector('.product-card__media');
    const slides = loopSlider.querySelectorAll('.loop-slider__slide');

    const currentSlide = slides[loopSlider.currentIndex];
    const currentMedia = currentSlide?.querySelector('.media')
      ?? productCardMedia?.querySelector('.media');

    if (!currentMedia) {
      loopSlider.currentIndex = 0;
      loopSlider.updatePositions({ animate: false });
      return;
    }

    const originalImages = Array.from(currentMedia.querySelectorAll('img:not(.image-hover)'));
    const originalSrcs = originalImages.map(img => ({ src: img.src, srcset: img.srcset }));

    this.imageAnimator.animate(currentMedia, src, () => {
      originalImages.forEach((img, i) => {
        img.src = originalSrcs[i].src;
        img.srcset = originalSrcs[i].srcset;
      });

      this._updateMediaContainers(src, true);

      loopSlider.currentIndex = 0;
      loopSlider.updatePositions({ animate: false });
    });
  }

  _updateVariantInputs(variantId) {
    const productForm = this.querySelector(`#product-form-${this.dataset.section}-${this.dataset.productId}`);
    if (!productForm) return;

    const input = productForm.querySelector('input[name="id"]');
    input.value = variantId ?? '';
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  _updateOptionValues(html) {
    const newVariantSelects = html.querySelector('variant-selects');
    const currentVariantSelects = this.variantSelectors;
    if (!newVariantSelects || !currentVariantSelects) return;

    const currentFieldsets = currentVariantSelects.querySelectorAll('fieldset.product-form__input, .product-form__input:not(fieldset)');
    const newFieldsets = newVariantSelects.querySelectorAll('fieldset.product-form__input, .product-form__input:not(fieldset)');

    currentFieldsets.forEach((fieldset, i) => {
      if (i === 0 || !newFieldsets[i]) return;

      const currentSelect = fieldset.querySelector('select');
      const newSelect = newFieldsets[i].querySelector('select');

      if (currentSelect && newSelect) {
        currentSelect.innerHTML = newSelect.innerHTML;
        currentSelect.value = newSelect.value;
      } else if (!currentSelect && !newSelect) {
        const currentGrid = fieldset.querySelector('.product-form__options-grid');
        const newGrid = newFieldsets[i].querySelector('.product-form__options-grid');
        if (currentGrid && newGrid) currentGrid.innerHTML = newGrid.innerHTML;
      }

      const currentValue = fieldset.querySelector('[data-selected-value]');
      const newValue = newFieldsets[i].querySelector('[data-selected-value]');
      if (currentValue && newValue) currentValue.textContent = newValue.textContent;
    });

    const currentScript = currentVariantSelects.querySelector('[data-selected-variant]');
    const newScript = newVariantSelects.querySelector('[data-selected-variant]');
    if (currentScript && newScript) currentScript.innerHTML = newScript.innerHTML;
  }

  _getSelectedVariant(productInfoNode) {
    const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
    return !!selectedVariant ? JSON.parse(selectedVariant) : null;
  }

  _buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
    const params = [];
    this.sectionId = `async-product-card-${this.dataset.picker}${this.dataset.picker === 'button' ? `-${this.dataset.swatchType}` : ''}`;

    !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

    if (optionValues.length) {
      params.push(`option_values=${optionValues.join(',')}`);
    }

    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${params.join('&')}`;
  }

  _renderProductInfo({ requestUrl, targetId, shouldRestoreFocus = false, callback }) {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const normalizedTargetId = targetId?.trim();

    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const processedResponseText = responseText.replace(/__sectionId__/g, this.dataset.section);
        const html = new DOMParser().parseFromString(processedResponseText, 'text/html');
        callback(html);
      })
      .then(() => {
        if (shouldRestoreFocus && normalizedTargetId) {
          this.querySelector(`#${CSS.escape(normalizedTargetId)}`)?.focus();
        }
        if (window.tooltipInstance) {
          window.tooltipInstance.init(this);
        }
      })
      .catch((error) => {
        if (error?.name === 'AbortError') return;
        throw error;
      });
  }

  _resetProductFormState() {
    const productForm = this.productForm;
    productForm?.toggleSubmitButton?.(true);
    productForm?.handleErrorMessage?.();
  }

  get variantSelectors() {
    return this.querySelector('variant-selects');
  }

  get productForm() {
    return this.querySelector('product-form');
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._moreOptionsCountRAF) cancelAnimationFrame(this._moreOptionsCountRAF);
    if (this._moreOptionsCountIdleTimer) clearTimeout(this._moreOptionsCountIdleTimer);
    this._moreOptionsCountRAF = null;
    this._moreOptionsCountIdleTimer = null;
    if (this._highlightObserver) {
      this._highlightObserver.disconnect();
      this._highlightObserver = null;
    }
    if (typeof this.onVariantChangeUnsubscriber === 'function') {
      this.onVariantChangeUnsubscriber();
      this.onVariantChangeUnsubscriber = null;
    }
  }

  scheduleMoreOptionsCountUpdate(lazy = false) {
    if (this._moreOptionsCountRAF) cancelAnimationFrame(this._moreOptionsCountRAF);
    if (this._moreOptionsCountIdleTimer) clearTimeout(this._moreOptionsCountIdleTimer);

    const run = () => {
      this._moreOptionsCountRAF = requestAnimationFrame(() => {
        this._moreOptionsCountRAF = null;
        this.updateMoreOptionsCount();
      });
    };

    if (lazy) {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(run, { timeout: 1200 });
      } else {
        this._moreOptionsCountIdleTimer = setTimeout(run, 200);
      }
      return;
    }

    run();
  }

  updateMoreOptionsCount() {
    const counter = this.querySelector('[data-count]');
    if (!counter) return;

    const breakpoints = [[576, 7], [768, 9], [992, 11], [1200, 13]];
    const vw = window.innerWidth || document.documentElement.clientWidth || 0;
    const visible = breakpoints.find(([bp]) => vw < bp)?.[1] ?? 15;

    const total = parseInt(counter.dataset.allCount, 10);
    if (Number.isNaN(total)) return;

    const rest = total - visible;
    const isHidden = rest <= 0;
    counter.classList.toggle('hidden', isHidden);
    counter.dataset.count = isHidden ? '' : rest;
  }
}

customElements.define('product-card', ProductCard);

class SizingObserver extends HTMLElement {
  static resizeObserverShared = null;
  static resizeObserverTargets = null;

  static getResizeObserver() {
    if (SizingObserver.resizeObserverShared) return SizingObserver.resizeObserverShared;

    SizingObserver.resizeObserverTargets = SizingObserver.resizeObserverTargets || new Map();
    SizingObserver.resizeObserverShared = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const instance = SizingObserver.resizeObserverTargets.get(entry.target);
        instance?.handleResizeEntry?.(entry);
      });
    });

    return SizingObserver.resizeObserverShared;
  }

  static observeTarget(instance, target) {
    if (!instance || !target) return;
    SizingObserver.resizeObserverTargets = SizingObserver.resizeObserverTargets || new Map();
    SizingObserver.resizeObserverTargets.set(target, instance);
    SizingObserver.getResizeObserver().observe(target);
  }

  static unobserveTarget(target) {
    if (!target || !SizingObserver.resizeObserverShared) return;

    SizingObserver.resizeObserverShared.unobserve(target);
    SizingObserver.resizeObserverTargets?.delete(target);

    if (SizingObserver.resizeObserverTargets?.size === 0) {
      SizingObserver.resizeObserverShared.disconnect();
      SizingObserver.resizeObserverShared = null;
      SizingObserver.resizeObserverTargets = null;
    }
  }

  constructor() {
    super();
    this.wrapper = null;
    this.resizeTarget = null;
    this.cssVariableName = '';
    this.wrapperSelector = '';
  }

  connectedCallback() {
    if (!this.wrapperSelector || !this.cssVariableName) {
      return;
    }

    this.wrapper = this.closest(this.wrapperSelector);
    if (!this.wrapper) return;

    this.resizeTarget = this.firstElementChild;
    if (!this.resizeTarget) return;

    SizingObserver.observeTarget(this, this.resizeTarget);
  }

  disconnectedCallback() {
    SizingObserver.unobserveTarget(this.resizeTarget);
    this.resizeTarget = null;
  }

  handleResizeEntry(entry) {
    if (!entry) return;
    this.updateOffset(entry.contentRect);
  }

  updateOffset(contentRect = null) {
    const size = this.getObservedSize(contentRect) || 0;

    this.wrapper.style.setProperty(this.cssVariableName, `${size}px`);
  }
}

class HeadingSide extends SizingObserver {
  constructor() {
    super();
    this.wrapperSelector = '.heading-wrapper';
    this.cssVariableName = '--heading-side-offset';
  }

  getObservedSize(contentRect) {
    return contentRect?.width || this.firstElementChild?.getBoundingClientRect().width || 0;
  }
}

customElements.define('heading-side', HeadingSide);

class BadgeWrapper extends SizingObserver {
  constructor() {
    super();
    this.wrapperSelector = '.banner-item__content-grid';
    this.cssVariableName = '--banner-bottom-padding';
  }

  getObservedSize(contentRect) {
    return contentRect?.height || this.firstElementChild?.getBoundingClientRect().height || 0;
  }
}

customElements.define('badge-wrapper', BadgeWrapper);

class ScrollActiveTags extends HTMLElement {
  connectedCallback() {
    requestAnimationFrame(() => {
      this._centerActiveTag();
    });
  }

  _centerActiveTag() {
    const activeTag = this.querySelector('.heading-tags__tag--active');
    if (!activeTag) return;

    const hasStart = this.classList.contains('heading-wrapper--start');

    activeTag.scrollIntoView({
      behavior: 'auto',
      block: 'nearest',
      inline: hasStart ? 'start' : 'center'
    });

    this.classList.remove('is-transparent');
  }
}

customElements.define('scroll-active-tags', ScrollActiveTags);

(function () {
  function fixSvgClipPaths(scope = document) {
    const svgs = scope.querySelectorAll('svg:not([data-clipfixed])');
    svgs.forEach((svg, svgIndex) => {
      svg.querySelectorAll('clipPath[id]').forEach((clipPath, clipIndex) => {
        const oldId = clipPath.id;
        const newId = `${oldId}__fixed_${svgIndex}_${clipIndex}`;

        clipPath.id = newId;

        svg.querySelectorAll(`[clip-path="url(#${oldId})"]`)
          .forEach(el => {
            el.setAttribute('clip-path', `url(#${newId})`);
          });
      });
      svg.setAttribute('data-clipfixed', 'true');
    });
  }

  window.fixSvgClipPaths = fixSvgClipPaths;

  function runWhenIdle() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => fixSvgClipPaths(document), { timeout: 2000 });
    } else {
      setTimeout(() => fixSvgClipPaths(document), 0);
    }
  }

  if (document.readyState === 'complete') {
    runWhenIdle();
  } else {
    window.addEventListener('load', runWhenIdle, { once: true });
  }
})();
